import React from 'react';

import { IClassName } from '@frontend/jetlend-core/src/models/common';
import styles from './ProgressCaption.module.scss';
import {
    buildClassNames,
    mergeClassNames,
} from '../../utils/classNameUtils';
import { getAssetSrc } from '@ui/utils/getAssetSrc';
import { getIcons } from './ProgressCaption.logic';

export type IconsType = 1 | 2 | 3;

export interface IProps extends IClassName {
    /**
     * Текст
     */
    title: string;
    /**
     * Флаг завершения
     */
    completed?: boolean;
    /**
     * Флаг загрузки
     */
    loading?: boolean;
    /**
     * Флаг дополнительного отступа снизу
     */
    extraMarginBottom?: boolean;
    /**
     * Флаг ограничения по ширине
     */
    shrink?: boolean;
    /**
     * Тип иконок
     */
    iconsType?: IconsType;
    /**
     * Флаг наличия рамки
     */
    bordered?: boolean;
    /**
     * Стили контейнера
     */
    containerClassName?: string;
}

/**
 * Компонент плашки с текстом и лоадером для отображения прогресса
 */
export default function ProgressCaption({
    title,
    completed,
    loading,
    extraMarginBottom = false,
    shrink,
    iconsType = 1,
    bordered,
    className,
    containerClassName,
}: IProps) {
    const captionClassNames = mergeClassNames([
        buildClassNames(styles, [
            'caption',
            extraMarginBottom && 'caption--extra-margin-bottom',
            shrink && 'caption--shrink',
            bordered && 'bordered',
        ]),
        containerClassName,
    ]);

    const iconClassNames = buildClassNames(styles, [
        'caption__icon',
        !completed && !loading && 'caption__icon--ban',
        bordered && 'bordered',
    ]);

    const titleClassNames = mergeClassNames([
        buildClassNames(styles, ['caption__title', bordered && 'bordered']),
        className,
    ]);

    const icons = getIcons(iconsType, { bordered });

    return (
        <div key={title} className={captionClassNames}>
            <span className={iconClassNames}>
                {completed && !loading && <img src={getAssetSrc(icons.success)} alt="success" />}
                {!completed && !loading && <img src={getAssetSrc(icons.error)} alt="error" />}
                {loading && icons.loading}
            </span>
            <span className={titleClassNames}>{title}</span>
        </div>
    );
};
